import { TRACKING_TAGS } from "./constants";
import { logEvent } from "./activityLog";

class EventLogger {
  constructor() {
    this.trackEvent = this.trackEvent.bind(this);
  }

  init() {
    document.addEventListener("click", this.trackEvent);
  }

  destroy() {
    document.removeEventListener("click", this.trackEvent);
  }

  async trackEvent(event) {
    try {
      let target = event.target;
      if (!target?.tagName) {
        return;
      }
      let tagName = target.tagName.toLowerCase();
      if (TRACKING_TAGS.indexOf(tagName) === -1) {
        while (target?.parentElement && TRACKING_TAGS.indexOf(tagName) === -1) {
          target = target.parentElement;
          tagName = target.tagName.toLowerCase();
        }
      }
      const page = window.location.href;
      const label = target.getAttribute("aria-label");
      let txt = target.textContent?.trim();
      if (txt) {
        txt = this.getOriginalText(txt);
      }
      let actionText =
        target.getAttribute("aria-describedby") ||
        txt ||
        target.name ||
        target.placeholder ||
        target.id ||
        target.getAttribute("data-testid");
      let action = this.formatAction(actionText);
      if (action) {
        action += `_${tagName}`;
      }

      if (
        action &&
        (TRACKING_TAGS.indexOf(tagName) > -1 || label === "tracker")
      ) {
        const eventData = {
          current: page,
          activity: `auto_click_${action}`,
          meta: {
            tagName,
            id: target.id || null,
            type: target.type,
            classList: Array.from(target.classList || []),
            name: target.name || null,
            placeholder: target.placeholder || null,
            attributes: this.getAttributes(target),
          },
        };
        await logEvent(eventData);
      }
    } catch (error) {
      // best-effort telemetry
    }
  }

  getAttributes(element) {
    const attributes = {};
    for (const attr of element.attributes) {
      attributes[attr.name] = attr.value;
    }
    return attributes;
  }

  formatAction(actionText) {
    if (!actionText) {
      return null;
    }
    actionText = actionText.split(".")[0];
    return actionText
      .toLowerCase()
      .split(/[ .,-]+/)
      .filter(Boolean)
      .join("_");
  }

  getOriginalText(translatedText) {
    return translatedText;
  }
}

export default EventLogger;
